import React from 'react';
import cx from 'classnames';
import LoginSlider from 'components/LoginSlider/LoginSlider';
import SignupImage from 'assets/images/signup.jpg';

function LoginSliderContainer({
  children,
  className,
  staticImage = false,
}: Readonly<React.PropsWithChildren<{ className?: string; staticImage: boolean }>>) {
  return (
    <div className="row col-12">
      <div className="col-lg-6 p-0">
        {staticImage ? (
          <img className="img-login-signup" src={SignupImage} alt="signup" />
        ) : (
          <LoginSlider />
        )}
      </div>

      <div
        className={cx(
          'col-12',
          'col-sm-10',
          'col-md-8',
          'col-lg-4',
          'offset-sm-1',
          'offset-md-2',
          'offset-lg-1',
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
}

export default LoginSliderContainer;
